import React, { ReactElement } from 'react';
import { Field } from 'react-final-form';
import FormFieldAdapter from '../form-field-adapter/form-field-adapter.component';

const FormFieldContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    name,
    onChange,
    children,
  } = props;

  return (
    <Field
      name={name}
      subscription={{
        value: true,
        active: true,
      }}
      render={(renderProps: ReactComponentProps): ReactElement => (
        <FormFieldAdapter onChange={onChange} {...renderProps}>
          {children}
        </FormFieldAdapter>
      )}
    />
  );
});

export default FormFieldContainer;
